import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';

import { Observable } from 'rxjs';

import { Response, ContractElectricity, ContractElectricityRequest } from '@core/api';

@Injectable({
  providedIn: 'root'
})
export class ContractElectricityService {
  constructor(private http: HttpClient) { }

  get(uuid: string): Observable<Response<ContractElectricity>> {
    const headers = new HttpHeaders({ 'content-type': 'application/json' });
    return this.http.post<Response<ContractElectricity>>(environment.apiUrl + '/api/ContractElectricity/Get', JSON.stringify(uuid), { headers });
  }

  insert(request: ContractElectricityRequest): Observable<Response<ContractElectricity>> {
    return this.http.post<Response<ContractElectricity>>(environment.apiUrl + '/api/ContractElectricity/Insert', request);
  }

  update(request: ContractElectricityRequest): Observable<Response<ContractElectricity>> {
    return this.http.post<Response<ContractElectricity>>(environment.apiUrl + '/api/ContractElectricity/Update', request);
  }
}
